import { FC } from 'react'
import cx from 'classnames'
import { ImageProps } from 'next/image'
import { useTheme } from 'styled-components'

import { MediaType } from '../../form/fields/FormFieldUploadMedia'
import { VideoProps } from '../Video'
import { Icons } from '../Icon'

import * as SC from './styled'

type MediaEditable = {
  onEdit?: () => void
  onDelete?: () => void
}

export type MediaProps = {
  className?: string
  type?: MediaType
  preview?: ImageProps
  previewVideo?: VideoProps
  editable?: MediaEditable
  onClick?: () => void
  clickable?: boolean
}

const Media: FC<MediaProps> = ({
  className,
  type,
  preview,
  previewVideo,
  editable,
  clickable,
  onClick,
}) => {
  const theme = useTheme()

  return (
    <SC.Wrapper>
      {editable && (
        <SC.Actions>
          <SC.Button onClick={editable.onEdit} type="button">
            <SC.EditIcon
              icon={Icons.edit}
              width={18}
              color={theme.colors.bluePrimary}
            />
          </SC.Button>
          <SC.Separator />
          <SC.Button onClick={editable.onDelete} type="button">
            <SC.DeleteIcon
              icon={Icons.delete}
              width={18}
              color={theme.colors.bluePrimary}
            />
          </SC.Button>
        </SC.Actions>
      )}
      <SC.Media
        className={cx('Media', className)}
        onClick={onClick}
        $clickable={clickable}
      >
        {type === MediaType.Document && (
          <SC.DocIcon
            icon={Icons.doc}
            width={36}
            color={theme.colors.pureBlack}
          />
        )}
        {type === MediaType.Video && !previewVideo && (
          <SC.YoutubeIcon
            icon={Icons.socialYoutube}
            width={56}
            color={theme.colors.pureBlack}
          />
        )}
        {type === MediaType.Photo && !preview && (
          <SC.ImageIcon
            icon={Icons.socialYoutube}
            width={36}
            color={theme.colors.pureBlack}
          />
        )}
        {preview && <SC.Preview {...preview} />}
        {previewVideo && <SC.PreviewVideo {...previewVideo} />}
      </SC.Media>
    </SC.Wrapper>
  )
}

export default Media
